import React from "react";

import IconButton from "components/Buttons/IconButton";
import DateCard from "components/Date/DateCard";
import ToolButton from "components/Buttons/ToolButton";
import SectionHeader from "./SectionHeader";

function ToolbarBoard(props) {
  const {
    ctxView,
    viewType,
    actions,
    onChangeView,
    onChangeDate,
    data,
    handleFilter,
  } = props;
  let buttons = [];
  if (viewType === "list" && actions) {
    if (actions.includes("date-card")) {
      buttons.push(<DateCard key="date-card" onChangeDate={onChangeDate} />);
    }
    if (actions.includes("add")) {
      buttons.push(
        <ToolButton
          key="add"
          action="add"
          label="add_record"
          handleAction={onChangeView}
        />,
      );
    }
  } else if (viewType === "form") {
    return;
  } else if (viewType === "attachment") {
    buttons.push(
      <IconButton
        onClick={(e) => onChangeView(e, "return")}
        color="green"
        size="w-40"
      />,
    );
  } else {
    buttons = null;
  }

  const activeSearch = props.activeSearch || ctxView.activeSearch;
  const countRecords = data ? data.length : 0;

  const searchables = [];
  for (const [field, attrs] of Object.entries(ctxView.webfields)) {
    if (attrs.searchable) {
      searchables.push({ name: field, type: attrs.type });
    }
  }

  return (
    <div className="flex w-full gap-x-2">
      <SectionHeader
        ctxView={ctxView}
        countRecords={countRecords}
        searchables={searchables}
        activeSearch={activeSearch}
        handleFilter={handleFilter}
      />
      <div className="flex py-3 gap-x-2">{buttons}</div>
    </div>
  );
}

export default ToolbarBoard;
